import React                               from 'react';
import { connect }                         from 'react-redux';
import { getPortfolioAction }              from '@/actions/trading';
import { dataType }                        from '../../../constants/data-type';
import { getSafe }                         from '@/helpers/global';
import { PARAMS as requestParams }         from '@/constants/params';
import { APP_LANGUAGE_SUPPORTS }           from '@/constants/app';
import { Converter, formatFunctions , utilsFunction }      from '../../../helpers/functions';
import { colorBindingTypes as colorTypes } from '../../../constants/color-binding-type';
import '../../../assets/styles/components/my-account/cash-account-profile-mobile.scss';
import TabHeader from '../../TabHeader/TabHeader';
import DefaultRankicon from '@/assets/images/icons/mobiles/sort_normal@2x.png';
import DownRankicon from '@/assets/images/icons/mobiles/sort_des@2x.png';
import RiseRankicon from '@/assets/images/icons/mobiles/sort_asc@2x.png';
import arrowDown from '@/assets/images/icons/mobiles/quote_icon_view10details@2x.png'
import { mobileSubLayoutAction } from "@/actions/app/mobileSubLayout.action";
import { LOADING_TYPE } from '@/constants/app';
import LoadingLayer from '../../Spinner/LoadingLayer';
import NoRow from '@/components/DataTable/CustomNoRow';
import { SERVICES_RESP } from '@/configurations';

class PortfolioMobile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      originData: null,
      market: 'all',
      marketData: [
        {
          label: 'All',
          value: 'all',
        },
        {
          label: 'HK',
          value: 'HKEX',
        },
      ],
      portfolioData: null,
      portfolioTab: [
        { id: 1, title: 'common_all' , value:'ALL'},
        { id: 2, title: 'market_hkex' , value:'HKEX'},
        { id: 3, title: 'market_mamk', value:'MAMK' },
        { id: 4, title: 'market_szmk' , value:'SZMK'},
        { id: 5, title: 'market_usex', value:'USEX' }
    ],
    sortType:null,
    totalMarket:"",
    initialData:'',
    load:false
    };
  }

  filterMarket = (val) => {
    const { originData, marketData } = this.state;
    this.setState({
      market: val,
    });
    if (!originData) return;
    let currentData;
    switch (val) {
      case marketData[1].value: {
        currentData = originData.filter(
            (item) => item.marketID === this.state.marketData[1].value
        );
        break;
      }
      default: {
        currentData = originData;
        break;
      }
    }
    this.setState({
      data: currentData,
    });
  };

  getPortfolio = (market) => {
    const { user, tradingAccount, language } = this.props;
    const { clientID } = tradingAccount;
    this.setState({portfolioData:null , load:true})
    const params = {
      [requestParams.CLIENT_ID]: clientID,
      [requestParams.TRADING_ACCOUNT_ID]: clientID,
      [requestParams.LANGUAGE]: language.lang,
      // [requestParams.TRADING_ACC_SEQ]: tradingAccSeq,
      [requestParams.MARKET_ID]: market,
      // [requestParams.CURRENCY_ID]: '',
      // [requestParams.INSTRUMENT_ID]: '',
      // [requestParams.IGNORE_ZERO_TRADABLE_QTY]: 'Y',
      // [requestParams.LIMIT]: -1
    };
    this.props.getAccountPortfolio(params, (res) => {
      if (res.errorCode === SERVICES_RESP.SUCCESS_CODE) {
        if (res.portfoliosList) {
          this.setState({ portfolioData: res.portfoliosList , totalMarket:res.totalMarket , initialData: JSON.parse(JSON.stringify(res.portfoliosList)),load:false});
        } else {
          this.setState({ portfolioData: [], totalMarket: '' })
        }
      } else {
        this.setState({ portfolioData: [], totalMarket: '' })
      }
      
    });
  };

    sortWathlist=(sortState)=>{
      if(this.state.portfolioData){
        const { sortType , portfolioData , initialData} = this.state
        if(sortType !==`${sortState}Rise` && sortType !==`${sortState}Down`){
          this.setState({sortType:`${sortState}Rise`},()=>{
            for ( let i=0;i<portfolioData.length-1;i++){
                for (let j=0;j<portfolioData.length-1-i;j++) {
                      if(Number(portfolioData[j][sortState] && Number(portfolioData[j + 1][sortState]))){
                        if(Number(portfolioData[j][sortState]) >  Number(portfolioData[j + 1][sortState])){
                          let temp = portfolioData[j];
                          portfolioData[j] = portfolioData[j + 1];
                          portfolioData[j + 1] = temp;
                        }
                      }else{
                        if(portfolioData[j][sortState] >  portfolioData[j + 1][sortState]){
                          let temp = portfolioData[j];
                          portfolioData[j] = portfolioData[j + 1];
                          portfolioData[j + 1] = temp;
                        }
                      }
                }
            } 
            this.setState({portfolioData})
          })
        }else if(sortType === `${sortState}Rise`){
          this.setState({sortType:`${sortState}Down`},()=>{
            for ( let i=0;i<portfolioData.length-1;i++){
              for (let j=0;j<portfolioData.length-1-i;j++) {
                if(Number(portfolioData[j][sortState] && Number(portfolioData[j + 1][sortState]))){
                  if(Number(portfolioData[j][sortState]) <  Number(portfolioData[j + 1][sortState])){
                    let temp = portfolioData[j];
                    portfolioData[j] = portfolioData[j + 1];
                    portfolioData[j + 1] = temp;
                  }
                }else{
                  if(portfolioData[j][sortState] <  portfolioData[j + 1][sortState]){
                    let temp = portfolioData[j];
                    portfolioData[j] = portfolioData[j + 1];
                    portfolioData[j + 1] = temp;
                  }
                }
              }
            } 
            this.setState({portfolioData},()=>{
            })
          })
        }else  if(sortType === `${sortState}Down`){
          this.setState({portfolioData : JSON.parse(JSON.stringify(initialData)),sortType:null})
        }
      }
  }

  handlefilterProtfolio=(market)=>{
    this.setState({sortType:null})
    let filted;
    if(this.state.initialData){
      filted = this.state.initialData.filter(item => market.main.value === 'ALL' || market.main.value === item.marketID)
    }else{
      filted = null
    }
    
    this.setState({portfolioData : JSON.stringify(filted) != '[]' ? filted : null})
  }

  componentDidMount() {
    this.getPortfolio('');
  }

  componentDidUpdate(preProps) {
    const { user , currentTradingAccount } = this.props;
    if (preProps.user !== user) {
      this.getPortfolio('');
    }
    if (preProps.currentTradingAccount !== currentTradingAccount && preProps.currentTradingAccount) {
      this.getPortfolio('');
    }
    if (this.props.isNeedRefresh && this.props.isNeedRefresh !== preProps.isNeedRefresh) {
      this.getPortfolio('')
      const img = document.getElementsByClassName('open-order-btn')
      for(let i=0;i<img.length;i++){
        img[i].style.transform=''
      }
    }
  }

  handleOpenOrderBtn=(e,index)=>{
    const { portfolioData } =this.state
    if(e.target.style.transform ){
      e.target.style.transform = ''
    }else{
      e.target.style.transform = 'rotate(180deg)'
    }
    portfolioData[index].openOrderBtn = !portfolioData[index].openOrderBtn
    this.setState({portfolioData})
  }

  render() {
    const { language , subLayout} = this.props;
    const { portfolioData , portfolioTab , sortType , totalMarket , load} = this.state;
    return (
        <React.Fragment>
          <div className="cash-account-container-profolio flex-items-start bg">
            {subLayout && <div className='portfolio-mkv-val-item'>
                <span>{language.portfolio_market_value}</span>
                <span>{formatFunctions.dataFormat(totalMarket, dataType.CASH)}</span>
            </div>}
            {<TabHeader tabs={portfolioTab} onChange={this.handlefilterProtfolio} justifyContent={'center'} />}
            <div className='rank-header'>
                <div onClick={()=>this.sortWathlist('stockCode')}>{language.common_symbol}/{language.common_name}<img src={sortType === 'stockCodeRise' ? RiseRankicon :  sortType === 'stockCodeDown' ? DownRankicon : DefaultRankicon}/> </div>
                <div onClick={()=>this.sortWathlist('marketValue')} style={{textAlign:'end'}}>{language.common_market_value}/{language.common_qty}<img src={sortType === 'marketValueRise' ? RiseRankicon :  sortType === 'marketValueDown' ? DownRankicon : DefaultRankicon}/></div>
                <div onClick={()=>this.sortWathlist('refPrice')} style={{textAlign:'end'}}>{language.common_price}/{language.mobile_common_cost}<img src={sortType === 'refPriceRise' ? RiseRankicon :  sortType === 'refPriceDown' ? DownRankicon : DefaultRankicon}/></div>
            </div>
            <LoadingLayer load={load} type={LOADING_TYPE.BIG_IMG} />
            {portfolioData ? <div className='data-lists' style={{height:'calc(100% - 112px)',overflowY:"auto",overflowX:'hidden'}}>
            {portfolioData?.map((item,index) => {
                    return (
                        <div className="data-list-container bg-box" key={item.stockCode} style={{marginBottom:item.openOrderBtn ? "10px" : "0px"}}>
                            <div className='data-list'>
                                <div className='symbol-name-item'>
                                    <span> {`${Converter.mappingMDSMarketToStock(item.marketID)}.${item.stockCode}`}</span>
                                    <span> {utilsFunction.switchToolTipsLanguage(language, item.stockShortName, item.stockChineseShortName)}</span>
                                </div>
                                <div className='mkv-qty-item'>
                                    <span> {formatFunctions.dataFormat(item.marketValue,dataType.CASH)}</span>
                                    <span> {formatFunctions.dataFormat(item.ledgerQty,dataType.NUMBER)}</span>
                                </div>
                                <div className='price-cost-item'>
                                    <span> {formatFunctions.dataFormat(item.refPrice,dataType.CURRENCY)}</span>
                                    <span> {formatFunctions.dataFormat(item.totalAverageCost,dataType.AVG_PRICE)}</span>
                                </div>
                                <img className='open-order-btn' src={arrowDown} onClick={(e)=>this.handleOpenOrderBtn(e,index)} />
                            </div>
                            <div className='pl-price'>
                                <span>{language.mobile_common_pl}</span>
                                <span  style={Converter.colorMapping(colorTypes.UP_DOWN,item.floatingPL)}>
                                    {`${formatFunctions.dataFormat(item.floatingPL,dataType.CASH)}(${formatFunctions.dataFormat(item.floatingPLPercent,dataType.PERCENT)})`}
                                </span>
                            </div>
                            {<div className='data-trade-container' 
                            style={{height:item.openOrderBtn ? '100px' : '0' , 
                            marginTop:!item.openOrderBtn ? "0" : '10px',
                            marginBottom:!item.openOrderBtn ? "0" : '10px'
                            }}>
                                <div className='data-list'>
                                    <div className='traQty-item'>
                                        <span> {language.common_tradable_quantity}</span>
                                        <span> {formatFunctions.dataFormat(item.tradableQty,dataType.NUMBER)}</span>
                                    </div>
                                    <div className='tdb-item'>
                                        <span> {language.current_account_today_confirm_buy}</span>
                                        <span> {formatFunctions.dataFormat(item.ttodayConfirmBuy,dataType.CURRENCY)}</span>
                                    </div>
                                    <div className='tds-item'>
                                        <span> {language.current_account_today_confirm_sell}</span>
                                        <span> {formatFunctions.dataFormat(item.ttodayConfirmSell,dataType.CURRENCY)}</span>
                                    </div>
                                </div>
                                <div className="action-btn-item">
                                    <button
                                        className="btn-table buy-btn"
                                        onClick={() => this.handleOpenPlaceOrderDialog(true, item)}
                                    >
                                        {language.common_buy}
                                    </button>
                                    <button
                                        className="btn-table sell-btn"
                                        onClick={() => this.handleOpenPlaceOrderDialog(false, item)}
                                    >
                                        {language.common_sell}
                                    </button>
                                </div>
                            </div>}
                        </div>
                    );
                })}  
            </div>
            : !load && <NoRow style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' , width :'100%'}} />
          }
            
          </div>
        </React.Fragment>
    );
  }


  handleFilter = (val) => {
    this.getPortfolio(val.value);
  }


  handleOpenPlaceOrderDialog = (direction, orderData) => {
    if (this.props.isMobile) {
        orderData.isBuy = direction;
        mobileSubLayoutAction.openPlaceOrder(orderData, true , true);
    } else {
        openPlaceOrderDialog(direction, orderData)
    }
};
}

export default connect(
    (state) => ({
      language: state.app.language,
      user: state.auth.user,
      tradingAccount: state.auth.tradingAccount,
      markets: state.trade.markets,
      isMobile: state.app.isMobile,
      isNeedRefresh: state.refresh.orderTable,
      currentTradingAccount: state.trade.currentTradingAccount,
    }),
    (dispatch) => ({
      getAccountPortfolio: (p, c) => dispatch(getPortfolioAction(p, c)),
    })
)(PortfolioMobile);
